import React, { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import * as DateFns from "date-fns";

import Table, { RowsType } from "../Shared/CustomTable";
import Loader from "../Shared/Loader";
import {
  getTeamProps,
  isCC,
  text_truncate,
} from "../../helpers/helpers";
import { useProfilesState } from "../../store/hooks";
import { Profile, ProfilesState } from "./types";
import { MESSAGES, SCOPE } from "config/constants";

type Props = {
  handleShow: (caller: string, profile?: Profile) => void;
  teamId: string;
};

const ProfilesPage = ({ handleShow, teamId }: Props) => {
  const { profiles: profilesById, user }: ProfilesState = useProfilesState();
  const [profiles, setProfiles] = useState<Array<Profile>>([]);

  useEffect(() => {
    const arrayProfiles: Profile[] = profilesById[teamId];

    if (arrayProfiles && arrayProfiles.length > 0) {
      setProfiles(arrayProfiles);
    }
  }, [profilesById, teamId]);

  // max-width = 1276
  const headers = isCC(user)
    ? [
        {
          content: "TEAM",
          style: { width: "88px" },
          class: "t-ll text-center",
          isOrderly: true,
        },
        {
          content: "TEMPLATE NAME",
          style: { width: "342px" },
          class: "t-ll",
          isOrderly: true,
          leftSortIcon: "90px",
        },
        {
          content: "LAST MODIFIED",
          style: { width: "202px" },
          class: "t-ll",
          isOrderly: true,
          leftSortIcon: "47px",
        },
        {
          content: "# OF PERIODS",
          style: { width: "640px" },
          isOrderly: true,
          leftSortIcon: "24px",
        },
      ]
    : [
        {
          content: "TEMPLATE NAME",
          style: { width: "342px" },
          class: "t-ll",
          isOrderly: true,
          leftSortIcon: "90px",
        },
        {
          content: "LAST MODIFIED",
          style: { width: "202px" },
          class: "t-ll",
          isOrderly: true,
          leftSortIcon: "47px",
        },
        {
          content: "# OF PERIODS",
          style: { width: "728px" },
          isOrderly: true,
          leftSortIcon: "24px",
        },
      ];
  let rows: RowsType<string, number> = [];
  if (profiles) {
    rows = profiles.map((profile, index) => {
      const teamOfProfile = getTeamProps(profile.teamId)
        ? getTeamProps(profile.teamId)
        : { teamAbbr: "CC" };
      const columns = [
        {
          content: profile.profileName,
          class: "t-ll",
          print: (content: string) => (
            <label title={content} className="pp-ww">
              {text_truncate(content, 30)}
            </label>
          ),
        },
        {
          content: profile.last_modified,
          print: (content: number) => (
            <label className="pp-ww">
              {DateFns.format(content, "MM/dd/yyyy hh:mm a")}
            </label>
          ),
          class: "t-ll",
        },
        {
          content: profile.drills.length,
          print: (content: number) => (
            <>
              <label className="pp-ww">{content}</label>
              <Button
                onClick={() => handleShow("edit", profile)}
                className="btn-blue btn-blueHover"
              >
                Edit
              </Button>
            </>
          ),
        },
      ];

      if (isCC(user)) {
        columns.unshift({
          content: (teamOfProfile && teamOfProfile.teamAbbr) || "",
          class: "t-ll text-center",

          // style: { textAlign: 'center' },
          print: (content: string) => (
            <img
              alt="gameimg"
              src={"/assets/images/logos/" + content + ".svg"}
              height="27px"
            />
          ),
        });
      }

      return {
        columns: columns,
        id: profile.id,
      };
    });
  }
  return (
    <>
      <Loader
        forceScope={SCOPE.PROFILES.PAGE}
        forceMessage={!profilesById[teamId] ? MESSAGES.EMPTY : ""}
      >
        <Table
          headers={headers}
          rows={rows}
          default={{ orderColumn: isCC(user) ? 3 : 2 }}
        />
      </Loader>
    </>
  );
};
export default ProfilesPage;